// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sz5p","largestCol":"styles_largestCol__1Z5YF","smallestCol":"styles_smallestCol__2APjR"};